<div class="dropdown form-control-container">
  <div
    class="input-group"
    [id]="'dropdown-' + columnId"
    [attr.data-bs-toggle]="isDropdownEnabled() ? 'dropdown' : null"
    [attr.aria-expanded]="isDropdownEnabled() ? 'false' : null"
    [class.disabled-dropdown]="!isDropdownEnabled()"
  >
      <span
      class="input-group-text"
      style="cursor: pointer; font-size: 12px"
      [style.cursor]="isDropdownEnabled() ? 'pointer' : 'not-allowed'"
      [class.text-muted]="!isDropdownEnabled()"
    >
      <i [class]="selectedOption().icon" [class.d-none]="!hasResult()"></i>
    </span>
    <input
      type="text"
      readonly
      class="form-control form-control-sm summary-input"
      [class.input-result]="hasResult()"
      [class.input-disabled]="!isDropdownEnabled()"
      [value]="currentDisplayLabel() || null"
      [title]="currentDisplayLabel()"
      [placeholder]="localizationResource.LanguageService+'::InputResumeSelect' | abpLocalization"
      [style.cursor]="isDropdownEnabled() ? 'pointer' : 'not-allowed'"
      [attr.disabled]="!isDropdownEnabled() ? true : null"
      style="cursor: pointer; font-size: 12px"
    />
    <span
      class="input-group-text"
      style="cursor: pointer; font-size: 12px"
      [style.cursor]="isDropdownEnabled() ? 'pointer' : 'not-allowed'"
      [class.text-muted]="!isDropdownEnabled()"
    >
      <i class="bi bi-chevron-down"></i>
    </span>
  </div>

  @if (isDropdownEnabled()) {
  <ul class="dropdown-menu" [attr.aria-labelledby]="'dropdown-' + columnId">
    @for (option of displayOptions(); track option.value) {
    <li>
      <a
        class="dropdown-item"
        [class.active]="!hasResult() && selectedOperation() === option.value"
        (click)="onOperationChange(option)"
      >
        <i [class]="option.icon" class="me-2"></i> {{ localizationResource.LanguageService +'::'+ option.label | abpLocalization }}
      </a>
    </li>
    <li>
      <hr>
    </li>
    }
  </ul>
  }
</div>
